import { BiUploadedDatasetView } from '@euler/model/bi/dataset';
import dayjs from 'dayjs';

/** A day as the BI pages say it: this year without the year. */
export function biDayText(iso: string): string {
  const day = dayjs(iso);
  return day.year() === dayjs().year()
    ? day.format('M月D日')
    : day.format('YYYY年M月D日');
}

/** What a dataset row says under its name: rows, uploader, last used. */
export function biDatasetFacts(
  dataset: BiUploadedDatasetView,
): Array<string | null> {
  return [
    `${dataset.rowCount.toLocaleString('zh-CN')} 行`,
    dataset.ownerName ? `${dataset.ownerName} 上传` : null,
    dataset.lastUsedAt
      ? `上次使用 ${biDayText(dataset.lastUsedAt)}`
      : `${biDayText(dataset.createdAt)}上传`,
  ];
}
